import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import configs from "constants/configs";
import { API_AUTH } from "service/common";
import { useSelector, useDispatch } from "react-redux";
import { Cookies } from "react-cookie";
export const BtnXuatDanhSach = () => {
  const dataSearch = useSelector((state) => state.dataSearchDuNoChoVay);
  const xuatExcel = () => () => {
    let { dateFrom, dateTo, kieuVay, tinhTrang } = dataSearch;

    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }

    link = link + `bao-cao/du-no-cho-vay-xuat-excel?dateFrom=${dateFrom}&dateTo=${dateTo}&kieuVay=${kieuVay}&tinhTrang=${tinhTrang}`;
    API_AUTH.get(link).then((res) => {
      var uri = "data:application/vnd.ms-excel," + encodeURIComponent(res.data);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download = "DuNoChoVay.xls";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };
  return (
    <>
      <a
        href={() => false}
        className="icon-bgnew color-print1"
        onClick={xuatExcel()}
      >
        <PopoversBootrap
          contentText="Xuất danh sách"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
         <img src="/app-assets/images/logo-print-v2.png" />
        </PopoversBootrap>
      </a>
    </>
  );
};
